import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ServiceProvider } from '../../../providers/ServiceProvider';
import { CurcesDetailPage } from '../CurcesDetail/CurcesDetail';

/*
  Generated class for the Curcess page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
    selector: 'page-Curcess',
    templateUrl: 'Curcess.html'
})
export class CurcessPage {
    Curses: any = [];
    tempCurses: any = [];
    a_CursesType: any = {};
    a_CursesTypeList: any = [];
    constructor(public navCtrl: NavController, public navParams: NavParams, public serviceProvider: ServiceProvider) {
        this.LoadData();
    }

    LoadData() {
        this.tempCurses.splice(0, this.Curses.length);
        this.serviceProvider.Get("/ISPA_acCourseList", false).then((result) => {
            let curses: any = result;
            curses.forEach((value, index) => {
                let data: any = value;
                let image: string = '';
                data.DetailedForm.forEach((data_value, data_index) => {
                    if (data_value.tODataDetailId == 88) {
                        image = data_value.cddValue_txt;
                    }
                    if (data_value.tODataDetailId == 87) {
                        data.stateId = data_value.cddValue;
                    }
                })
                data.image = image;
                this.tempCurses.push(data);
            });
            this.Curses = this.tempCurses.slice(0).sort((a, b) => a.stateId - b.stateId);
            console.log(this.Curses);
        });
        this.a_CursesTypeList.splice(0, this.a_CursesTypeList.length);
        this.serviceProvider.Get("/ISPA_VFCombo/12", false).then((result) => {
            let cursestype: any = result;
            cursestype.forEach((value, index) => {
                this.a_CursesTypeList.push(value);
            });
        });
    }
    CursestypeChange() {
        console.log(this.a_CursesType);
        this.tempCurses.forEach((value, index) => {

        });
    }
    ShowCurseDetails(curse) {
        this.navCtrl.push(CurcesDetailPage, { curseData: curse });
    }

}



// WEBPACK FOOTER //
// ./src/pages/academy/Curcess/Curcess.ts